import React from 'react';


const RadioButton = ({ selected = false, className = "", onClick}) => {
    return(
        <>
            <button 
                className={`d-flex flex-grow-0 justify-content-center full-rounded ${ selected ? "bg-gradient" : "bg-grey" } p-2 align-items-center ${className ? className : ""} btn`} 
                onClick={onClick}
            >
                <div className={`size_8 ${ selected ? "bg-white" : "" } full-rounded`} />
                
            </button>
        </>
    )
}

export default RadioButton;